import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Button, Icon } from '../..'
import { useTranslation } from '../../../utils/providers'

function QtyInput({
  productId,
  qty,
  setQty,
  name = 'qty',
  min = 1,
  max = 10,
  disabled,
  className,
}) {
  const { t } = useTranslation()

  const increaseQty = () => {
    if (qty < max) {
      setQty(qty + 1)
    }
  }

  const decreaseQty = () => {
    if (qty > min) {
      setQty(qty - 1)
    }
  }

  const htmlId = `${name}-${productId}`
  const wrapperClasses = classNames('qty-input', className, {
    'qty-input--disabled': disabled,
  })

  return (
    <div className={wrapperClasses}>
      <label htmlFor={htmlId} className="sr-only">
        {t('QTY_SELECT_LABEL')}
      </label>
      <Button
        variant="inline"
        className="qty-input__button"
        onClick={decreaseQty}
        title={t('QTY_INPUT_BUTTON_DECREASE')}
        aria-label={t('QTY_INPUT_BUTTON_DECREASE')}
        aria-controls={htmlId}
        disabled={disabled || qty <= min}
        data-testid="qty-button-decrease"
      >
        <Icon symbol="cf-minus" />
      </Button>
      <input
        className="qty-input__input-field"
        type="number"
        min={min}
        max={max}
        name={name}
        id={htmlId}
        value={qty}
        readOnly
        data-testid="qty-input"
      />
      <Button
        variant="inline"
        className="qty-input__button"
        onClick={increaseQty}
        title={t('QTY_INPUT_BUTTON_INCREASE')}
        aria-label={t('QTY_INPUT_BUTTON_INCREASE')}
        aria-controls={htmlId}
        disabled={disabled || qty >= max}
        data-testid="qty-button-increase"
      >
        <Icon symbol="cf-plus" />
      </Button>
    </div>
  )
}

QtyInput.propTypes = {
  productId: PropTypes.string.isRequired,
  qty: PropTypes.number.isRequired,
  setQty: PropTypes.func.isRequired,
  name: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default QtyInput
